import Vue from 'vue';
import Vuex, {StoreOptions} from 'vuex';
import {datapoints} from './modules/datapoints';
import {actions} from './actions';
import {mutations} from './mutations';
import {getters} from './getters';
import {config} from "@/store/modules/config";
// import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);

export interface RootState {
    idleVue: any
}

export const rootState: RootState = {
    idleVue: {} as any
}

const store: StoreOptions<RootState> = {
    state: rootState,
    actions,
    getters,
    mutations,
    modules: {
        config,
        datapoints
    }
};

export default new Vuex.Store<RootState>(
    store
);
